import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select'; // Import the NzSelectModule
import { APIService } from '../../../services/api/api.service';
import { firstValueFrom } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'portals-emr-variant-select',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    FormsModule
  ], // Add FormsModule to the imports array
  template: `
    <!-- Inline HTML goes here -->
    <ng-container *ngIf="isEditable; else readonly">
      <nz-select
        [(ngModel)]="variantId"
        (ngModelChange)="onVariantSelect()"
        [nzShowSearch]="true"
      >
        <nz-option
          *ngFor="let variant of variantOptions"
          [nzValue]="'' + variant.id"
          [nzLabel]="variant.option_values[0]?.label"
        ></nz-option>
      </nz-select>
    </ng-container>
    <ng-template #readonly>
      {{ getVariantLabel(variantId) }}
    </ng-template>
  `,
  styles: [
    `
      /* Inline styles go here */
    `
  ]
})
export class VariantSelectComponent implements OnInit {
  @Input() productId: string;
  @Input() variantId?: string;
  @Input() isEditable: boolean = true;

  @Output() selectedVariant = new EventEmitter<any>(); // Remove the type argument from the EventEmitter declaration
  variantOptions: any[] = [];
  constructor(private readonly apiService: APIService) {}

  get _selectedVariant() {
    return this.variantOptions.find(v => '' + v.id === this.variantId) || null;
  }

  ngOnInit(): void {
    if (this.productId && this.variantId) {
      this.loadVariantOptions();
    }
  }

  loadVariantOptions() {
    // todo replace this with facade after merging the product management PR
    firstValueFrom(this.apiService.getProductVariants(this.productId))
      .then(variants => {
        this.variantOptions = variants;
        this.variantId = this.variantId || variants[0]?.id;
      })
      .catch(err => {
        console.error('Error loading variant options', err);
      });
  }

  onVariantSelect() {
    this.selectedVariant.emit({
      id: String(this._selectedVariant?.id || ''),
      sku: this._selectedVariant?.sku,
      price:
        this._selectedVariant.price ||
        this._selectedVariant.calculated_price ||
        0,
      salePrice: this._selectedVariant.sale_price
    });
  }

  getVariantLabel(variantId: string) {
    return this.variantOptions.find(v => '' + v.id === variantId)
      ?.option_values[0]?.label;
  }
}
